var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.isLoading,
          expression: "isLoading",
        },
      ],
      staticClass: "content",
    },
    [
      _vm.user
        ? _c(
            "el-tabs",
            {
              staticClass: "tabs",
              model: {
                value: _vm.active,
                callback: function ($$v) {
                  _vm.active = $$v
                },
                expression: "active",
              },
            },
            [
              _c(
                "el-tab-pane",
                {
                  attrs: {
                    label: _vm.$t("UserInfo.title07"),
                    name: "contract",
                  },
                },
                [
                  _c(
                    "section",
                    { staticClass: "contracted_cuona" },
                    [
                      _c("h2", [_vm._v(_vm._s(_vm.$t("UserInfo.title01")))]),
                      _c(
                        "el-row",
                        [
                          _c("el-col", { attrs: { span: 12 } }, [
                            _c("img", {
                              staticClass: "cube",
                              attrs: { src: _vm.images.cube },
                            }),
                            _c("div", { staticClass: "space" }, [
                              _c("p", { staticClass: "counter" }, [
                                _c("span", { staticClass: "title" }, [
                                  _vm._v(
                                    _vm._s(_vm.$t("UserInfo.contract_num"))
                                  ),
                                ]),
                                _c("span", { staticClass: "count" }, [
                                  _vm._v(_vm._s(_vm.company.num_cube_devices)),
                                ]),
                              ]),
                            ]),
                          ]),
                          _c("el-col", { attrs: { span: 12 } }, [
                            _c("img", {
                              staticClass: "tag",
                              attrs: { src: _vm.images.tag },
                            }),
                            _c("div", { staticClass: "space" }, [
                              _c("p", { staticClass: "counter" }, [
                                _c("span", { staticClass: "title" }, [
                                  _vm._v(
                                    _vm._s(_vm.$t("UserInfo.contract_num"))
                                  ),
                                ]),
                                _c("span", { staticClass: "count" }, [
                                  _vm._v(_vm._s(_vm.company.num_tag_devices)),
                                ]),
                              ]),
                            ]),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "section",
                    { staticClass: "contracted_plugins" },
                    [
                      _c("h2", [_vm._v(_vm._s(_vm.$t("UserInfo.pluginList")))]),
                      _c("plugins", {
                        attrs: { plugins: _vm.plugins },
                        on: {
                          "update:plugins": function ($event) {
                            _vm.plugins = $event
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ]
              ),
              _c(
                "el-tab-pane",
                { attrs: { label: _vm.$t("UserInfo.title08"), name: "info" } },
                [
                  _c(
                    "section",
                    { staticClass: "info" },
                    [
                      _c(
                        "h2",
                        [
                          _vm._v(_vm._s(_vm.$t("UserInfo.title03"))),
                          _vm.user.role !== "manager"
                            ? _c(
                                "el-button",
                                {
                                  attrs: { size: "mini", icon: "el-icon-edit" },
                                  on: { click: _vm.openUserEditDialog },
                                },
                                [_vm._v(_vm._s(_vm.$t("UserInfo.editButton")))]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                      _c("h3", [_vm._v(_vm._s(_vm.$t("UserInfo.title04")))]),
                      _c(
                        "el-row",
                        [
                          _c("el-col", [
                            _c("p", [
                              _c("span", { staticClass: "name" }, [
                                _vm._v(_vm._s(_vm.company.name)),
                              ]),
                              _c("span", { staticClass: "kana" }, [
                                _vm._v(_vm._s(_vm.company.name_kana)),
                              ]),
                            ]),
                            _c("p", [
                              _c("span", { staticClass: "address" }, [
                                _vm._v(_vm._s(_vm.company.address)),
                              ]),
                              _c("span", { staticClass: "phone" }, [
                                _vm._v(_vm._s(_vm.company.phone_number)),
                              ]),
                              _c("span", { staticClass: "fax" }, [
                                _vm._v(_vm._s(_vm.company.fax_number)),
                              ]),
                            ]),
                          ]),
                        ],
                        1
                      ),
                      _c("h3", [_vm._v(_vm._s(_vm.$t("UserInfo.title05")))]),
                      _c(
                        "el-row",
                        [
                          _c("el-col", [
                            _c("p", [
                              _c("span", { staticClass: "name" }, [
                                _vm._v(_vm._s(_vm.user.name)),
                              ]),
                              _c("span", { staticClass: "kana" }, [
                                _vm._v(_vm._s(_vm.user.name_kana)),
                              ]),
                              _c("span", { staticClass: "email" }, [
                                _vm._v(_vm._s(_vm.user.email)),
                              ]),
                            ]),
                          ]),
                        ],
                        1
                      ),
                      _vm.user.notes !== null
                        ? [
                            _c("h3", [_vm._v(_vm._s(_vm.$t("UserInfo.note")))]),
                            _c(
                              "el-row",
                              [
                                _c("el-col", [
                                  _c("p", {
                                    staticClass: "note",
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.nl2br(_vm.user.notes)
                                      ),
                                    },
                                  }),
                                ]),
                              ],
                              1
                            ),
                          ]
                        : _vm._e(),
                      _c("h3", [_vm._v(_vm._s(_vm.$t("UserInfo.sdkToken")))]),
                      _c(
                        "el-row",
                        [
                          _c("el-col", [
                            _c(
                              "p",
                              [
                                _c("span", { staticClass: "sdk" }, [
                                  _vm._v(_vm._s(_vm.company.sdk_token)),
                                ]),
                                _c(
                                  "el-tooltip",
                                  {
                                    attrs: {
                                      placement: "top",
                                      content: _vm.$t(
                                        "UserInfo.copySdkTokenTooltip"
                                      ),
                                    },
                                  },
                                  [
                                    _c(
                                      "a",
                                      {
                                        on: {
                                          click: function ($event) {
                                            return _vm.copySDKToken(
                                              _vm.company.sdk_token
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "el-icon-copy-document",
                                        }),
                                      ]
                                    ),
                                  ]
                                ),
                                _c(
                                  "el-dropdown",
                                  {
                                    attrs: {
                                      size: "small",
                                      placement: "bottom-start",
                                    },
                                  },
                                  [
                                    _c("el-button", {
                                      attrs: {
                                        type: "text",
                                        icon: "el-icon-more",
                                      },
                                    }),
                                    _c(
                                      "el-dropdown-menu",
                                      {
                                        attrs: { slot: "dropdown" },
                                        slot: "dropdown",
                                      },
                                      [
                                        _c("el-dropdown-item", [
                                          _c(
                                            "a",
                                            {
                                              on: {
                                                click: function ($event) {
                                                  _vm.isShowingResetDialog = true
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "UserInfo.resetSdkTokenButton"
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                        ]),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]),
                        ],
                        1
                      ),
                    ],
                    2
                  ),
                ]
              ),
              _c(
                "el-dialog",
                {
                  staticClass: "resetTokenDialog",
                  attrs: {
                    title: _vm.$t("UserInfo.resetSdkTokenWindowTitle"),
                    visible: _vm.isShowingResetDialog,
                  },
                  on: {
                    "update:visible": function ($event) {
                      _vm.isShowingResetDialog = $event
                    },
                  },
                },
                [
                  _c("p", {
                    staticClass: "message",
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.$t("UserInfo.resetSdkTokenDescription")
                      ),
                    },
                  }),
                  _c("el-input", {
                    attrs: {
                      placeholder: _vm.$t("UserInfo.checkSdkTokenResetWord"),
                    },
                    model: {
                      value: _vm.checkReset,
                      callback: function ($$v) {
                        _vm.checkReset = $$v
                      },
                      expression: "checkReset",
                    },
                  }),
                  _c(
                    "span",
                    {
                      staticClass: "dialog-footer",
                      attrs: { slot: "footer" },
                      slot: "footer",
                    },
                    [
                      _c(
                        "el-button",
                        {
                          on: {
                            click: function ($event) {
                              _vm.isShowingResetDialog = false
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("UserInfo.cancelButton")))]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "danger", disabled: _vm.checkWord() },
                          on: { click: _vm.resetSdkToken },
                        },
                        [_vm._v(_vm._s(_vm.$t("UserInfo.doReset")))]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-dialog",
                {
                  staticClass: "edit-user-dialog",
                  attrs: {
                    title: _vm.$t("UserInfo.title06"),
                    visible: _vm.isShowingUserEditDialog,
                  },
                  on: {
                    "update:visible": function ($event) {
                      _vm.isShowingUserEditDialog = $event
                    },
                  },
                },
                [
                  _c(
                    "el-form",
                    {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.isLoading,
                          expression: "isLoading",
                        },
                      ],
                      ref: "userEditDialogForm",
                      attrs: {
                        "label-position": "left",
                        rules: _vm.rules,
                        "label-width": "160px",
                        model: _vm.userEditDialogForm,
                      },
                    },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("UserInfo.staff_name"),
                            prop: "name",
                          },
                        },
                        [
                          _c("el-input", {
                            model: {
                              value: _vm.userEditDialogForm.name,
                              callback: function ($$v) {
                                _vm.$set(_vm.userEditDialogForm, "name", $$v)
                              },
                              expression: "userEditDialogForm.name",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm.$i18n.locale === "ja"
                        ? _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("UserInfo.staff_name_furi"),
                                prop: "name_kana",
                              },
                            },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.userEditDialogForm.name_kana,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.userEditDialogForm,
                                      "name_kana",
                                      $$v
                                    )
                                  },
                                  expression: "userEditDialogForm.name_kana",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("UserInfo.email"),
                            prop: "email",
                          },
                        },
                        [
                          _c("el-input", {
                            model: {
                              value: _vm.userEditDialogForm.email,
                              callback: function ($$v) {
                                _vm.$set(_vm.userEditDialogForm, "email", $$v)
                              },
                              expression: "userEditDialogForm.email",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("UserInfo.note") } },
                        [
                          _c("el-input", {
                            attrs: { type: "textarea", rows: 3 },
                            model: {
                              value: _vm.userEditDialogForm.notes,
                              callback: function ($$v) {
                                _vm.$set(_vm.userEditDialogForm, "notes", $$v)
                              },
                              expression: "userEditDialogForm.notes",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "span",
                    {
                      staticClass: "dialog-footer",
                      attrs: { slot: "footer" },
                      slot: "footer",
                    },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { disabled: _vm.isLoading },
                          on: {
                            click: function ($event) {
                              _vm.isShowingUserEditDialog = false
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("UserInfo.cancelButton")))]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: {
                            type: "primary",
                            loading: _vm.isLoading,
                            disabled: _vm.isLoading,
                          },
                          on: { click: _vm.updateUser },
                        },
                        [_vm._v(_vm._s(_vm.$t("UserInfo.sendButton")))]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }